export default "__VITE_ASSET__DWjdQeqd__"